import { ACCESS_TOKEN_LOCAL_STORAGE_KEY, ID_TOKEN_LOCAL_STORAGE_KEY } from '../../services/utils';
import MicrosoftGraphService from '../../services/MicrosoftGraphService';
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { adApiTokenConfig, msalInstance } from './msalInstance';

type Group = {
  id: string;
  ext7n61chin_organizationSettings?: {
    name: string;
    isOrganization: boolean;
  };
  ext1y2agk0u_organizationSettings?: {
    name: string;
    isOrganization: boolean;
  };
};

export const setTokensToLocalStorage = (idToken: string, accessToken: string) => {
  window.localStorage.setItem(ID_TOKEN_LOCAL_STORAGE_KEY, idToken);
  window.localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, accessToken);
};

export const removeTokensFromLocalStorage = () => {
  window.localStorage.removeItem(ID_TOKEN_LOCAL_STORAGE_KEY);
  window.localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
};

export const getOrganizationId = async (setError: (err: string) => void) => {
  const groups = await MicrosoftGraphService.organizationId();
  const organizationGroup = groups.data.value.filter((group: Group) => {
    if (group.ext7n61chin_organizationSettings) {
      return group.ext7n61chin_organizationSettings.isOrganization;
    }
    if (group.ext1y2agk0u_organizationSettings) {
      return group.ext1y2agk0u_organizationSettings.isOrganization;
    }
    return false;
  });

  if (!organizationGroup.length) {
    setError('Invalid user. The authenticated user is missing an organization.');
  }
  if (organizationGroup.length > 1) {
    setError('Invalid user. The authenticated user has more than one organization.');
  }

  return organizationGroup[0].id;
};

export const getTokenSilent = async (): Promise<AuthenticationResult | null> => {
  const activeAccount = msalInstance.getActiveAccount();

  const silentRequest = {
    ...adApiTokenConfig,
    activeAccount
  };
  const interactiveRequest = {
    ...adApiTokenConfig,
    loginHint: activeAccount?.username
  };

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
    setTokensToLocalStorage(tokenResponse.idToken, tokenResponse.accessToken);
    return tokenResponse;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      removeTokensFromLocalStorage();
      msalInstance.acquireTokenRedirect(interactiveRequest).catch(console.error);
    } else {
      console.log(error);
    }
  }
  return null;
};
